const items = [
  "Courtage Énergie",
  "Indépendance Totale",
  "Formation de Pointe",
  "Marque Forte",
  "7 Agences — 2027",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section data-testid="editorial-marquee" className="relative border-y border-emerald-400/10 bg-[#0E1713]/60 py-6 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`font-display font-bold uppercase tracking-tight text-2xl md:text-4xl px-8 ${
                    i % 2 === 0 ? "text-slate-200" : "text-stroke-emerald"
                  }`}
                >
                  {item}
                </span>
                <span className="w-2 h-2 rotate-45 bg-emerald-400/50 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
